import PageWrapper from "../../../../../components/common/layout/PageWrapper";
import React from "react";
import { useTranslation } from "react-i18next";
import EmailTemplates from "../../../../../components/admin/emails/templates/EmailTemplates";

const EmailTemplatesManagement = () => {
  const { t } = useTranslation();

  return (
    <PageWrapper title={t("t.page.email.templates.admin")}>
      <EmailTemplates />
    </PageWrapper>
  );
};

export default EmailTemplatesManagement;
